<template>
  <v-toolbar-items class="header-responsive">
    <v-btn
      icon
      class="header-dialog"
      @click="$emit('open')"
    >
      <v-icon>menu</v-icon>
    </v-btn>
  </v-toolbar-items>
</template>
<script>
export default {
  name: 'ResponsiveNavigation',
}
</script>
<style scoped>
.header-dialog {
  height: 100% !important;
  margin: 0;
  margin-right: 30px !important;
}
</style>
